<mat-card class="exams-list-card mb-0">
  <app-card-header [title]="blockData.title" [icon]="blockData.icon" />

  <mat-card-content>
    <div class="row">
      <div class="col">
        <app-exams-list [blockData]="blockData" />
      </div>

      <div class="col useful-links-col">
        <app-useful-links [title]="blockData.usefulLinksHeader" [links]="usefulLinks" />
      </div>
    </div>
  </mat-card-content>
</mat-card>

<mat-card class="mb-0 useful-links-card">
  <mat-card-content>
    <app-useful-links [title]="blockData.usefulLinksHeader" [links]="usefulLinks" />
  </mat-card-content>
</mat-card>
